module.exports = __webpack_public_path__ + "static/media/iar_vehicle_police_hover.238bba06.svg";